import { Duration, FormatDistanceToken, formatDuration } from 'date-fns';

const FORMAT_DISTANCE_LOCALE: Partial<Record<FormatDistanceToken, string>> = {
  xMinutes: '{{count}}m',
  xHours: '{{count}}h',
  xDays: '{{count}}d',
  xMonths: '{{count}}M',
  xYears: '{{count}}y',
  xSeconds: '{{count}}s',
};
export const formatDurationShort = (
  duration: Duration,
  options?: { showZeroSeconds?: boolean },
) => {
  const base = formatDuration(duration, {
    format: ['years', 'months', 'days', 'hours', 'minutes', 'seconds'],
    locale: {
      formatDistance: (token, count) => {
        const match = FORMAT_DISTANCE_LOCALE[token];
        if (match) {
          return match.replace('{{count}}', count.toString());
        }
        console.error(`Missing FORMAT_DISTANCE_LOCALE for ${token}`);

        return `${count} ${token}`;
      },
    },
  });

  if (options?.showZeroSeconds) {
    const secondsVal = duration.seconds ?? 0;
    if (secondsVal === 0) {
      return base ? `${base} 00s` : '00s';
    }
  }

  return base;
};
